import React, { useState, useEffect } from "react";
import { DatePicker, Select, Table, Card,Spin } from "antd";
import dayjs from "dayjs";

import { toast } from "react-toastify";
import { Databases, Query } from "appwrite";
import appwriteClient from '../appwrite.config';
import Navbar from "../components/Navbar";

const { RangePicker } = DatePicker;
const content = {
    padding: 50,
    background: 'rgba(0, 0, 0, 0.05)',
    borderRadius: 4,
  };


const UserActivity = () => {
      const databases = new Databases(appwriteClient);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [loginRecords, setLoginRecords] = useState([]);
  const [loading,setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await databases.listDocuments("AppwriteCloudFEApp", "UserRegister");
        setUsers(response.documents);
      } catch (error) {
        toast.error("Error fetching users")
        console.error("Error fetching users:", error);
      } finally{
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const fetchLoginRecords = async () => {
    if (!selectedUser || !dateRange.length) return;
    try {
        setLoading(true)
        setLoginRecords([])
        console.log(selectedUser+" -> "+dateRange[0].replace("-","/").replace("-","/")+" -> "+dateRange[1].replace("-","/").replace("-","/"))
      const response = await databases.listDocuments("AppwriteCloudFEApp", "LoginRecords",[
        Query.equal("userProviderUid",selectedUser),
        Query.greaterThanEqual("loginDate",dateRange[0].replace("-","/").replace("-","/")),
        Query.lessThanEqual("loginDate",dateRange[1].replace("-","/").replace("-","/")),
        Query.orderDesc("$createdAt"),
        Query.limit(5000)
      ]);
      setLoginRecords(response.documents);
    } catch (error) {
        toast.error("Error fetching Login Records")

      console.error("Error fetching login records:", error);
    }
    finally{
        setLoading(false)
    }
  };

  const fetchActivityData = async () => {
    if (!selectedUser || !dateRange.length) return;
    try {
        setLoading(true)
        setActivityData([])
      const response = await databases.listDocuments("AppwriteCloudFEApp", "VisitingRecords", [
        Query.equal("user",selectedUser),
        Query.greaterThanEqual("date",dateRange[0].replace("-","/").replace("-","/")),
        Query.lessThanEqual("date",dateRange[1].replace("-","/").replace("-","/")),

        Query.orderDesc("$createdAt"),
        Query.limit(5000)
      ]);
      setActivityData(response.documents);
      console.log(response.documents)
    } catch (error) {
        toast.error("Error fetching User Visiting Records")

      console.error("Error fetching activity data:", error);
    }
    finally{
        setLoading(false);
    }
  };

  const handleFetchData = () => {
    fetchLoginRecords();
    fetchActivityData();
  };

  return (
    <>
      <Navbar page={"User Activity"} />
    <div className="p-6 bg-gray-100 min-h-screen">
    <Spin tip="Loading..." spinning={loading} size="large">
      <div className="bg-white p-6 shadow-lg rounded-lg mb-6">
        <h2 className="text-xl font-semibold mb-4">User Activity Tracker</h2>
        <div className="flex gap-4 items-center mb-4">
          <Select
            className="w-1/3"
            placeholder="Select User"
            options={users.map((user) => ({ value: user.email, label: user.displayName }))}
            onChange={(e) => setSelectedUser(e)}
          />
          <RangePicker
            className="w-1/3"
            onChange={(dates) => setDateRange(dates.map((d) => d.format("YYYY-MM-DD")))}
          />
          <button
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
            onClick={handleFetchData}
          >
            Fetch Data
          </button>
        </div>
      </div>

      {loginRecords.length === 0 ? (
        <div className="text-center text-gray-500">No login records found.</div>
      ) : (
        loginRecords.map((login, index) => (
          <Card key={index} className="mb-4 shadow-md">
            <h3 className="text-lg font-semibold mb-2">{dayjs(login.loginDate).format("DD MMM YYYY")}</h3>
            <p className="text-sm text-gray-700">Login Time: {login.loginTime}</p>
            {activityData.filter(
              (activity) =>
                activity.date === login.loginDate &&
                activity.entryTime >= login.loginTime &&
                activity.entryTime <= (login.logoutTime || "22:00")
            ).length ? (
              <Table
                className="my-4"
                dataSource={activityData.filter(
                  (activity) =>
                    activity.date === login.loginDate &&
                    activity.entryTime >= login.loginTime &&
                    activity.entryTime <= (login.logoutTime || "22:00")
                )}
                columns={[
                  {
                    title: "Fleet Profile",
                    dataIndex: "fleetProfile",
                    render(fleet) {
                      return fleet.fleetname;
                    },
                  },
                  { title: "Entry Time", dataIndex: "entryTime" },
                  { title: "Exit Time", dataIndex: "exitTime" },
                  { title: "Exit Note", dataIndex: "exitNote" },
                ]}
                pagination={false}
              />
            ) : (
              <p className="text-sm text-gray-500">No Visiting Records for this Login</p>
            )}
            <p className="text-sm text-gray-700">Logout Time: {login.logoutTime || "22:00"}</p>
          </Card>
        ))
      )}
    </Spin>
  </div>
  </>
  );
};

export default UserActivity;
